/* Mas Laus: dydžio įrankis puslapyje „Kaip teisingai išsimatuoti pėdą?" – modelio pasirinkimas, dydis, pridėjimas į krepšelį (2026-11-03). Modeliai: kolekcijos moteriski ir vyriski. */
(function () {
  var mount = document.querySelector('[data-ml-spt]');
  if (!mount || mount.__ml) return;
  mount.__ml = true;
  var EMAIL = 'hello@maslaus.com', PHONE = '+37065290897', PHONE_TXT = '+370 652 90897';
  var FIT = 'Dydžiai atitinka standartą, 9 iš 10 tinka įprastai nešiojamas batų dydis.';
  var COLS = [['moteriski', 'Moteriški'], ['vyriski', 'Vyriški']];
  var groups = null, st = { handle: '', chart: null, prod: null, size: null };

  function num(s) { var v = parseFloat(String(s).replace(',', '.')); return isNaN(v) ? null : v; }
  function fmt(v) { return (Math.round(v * 10) / 10).toFixed(1).replace('.', ','); }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

  function parseChart(doc) {
    var tb = doc.querySelector('x-modal table'); if (!tb) return null;
    var modal = tb.closest('x-modal');
    var rows = [].slice.call(tb.querySelectorAll('tr')).map(function (tr) {
      return [].slice.call(tr.querySelectorAll('td,th')).map(function (c) { return c.textContent.replace(/\s+/g, ' ').trim(); });
    }).filter(function (r) { return r.length >= 2; });
    if (rows.length < 3) return null;
    var m = modal.textContent.replace(/\s+/g, ' ').match(/bent\s*(\d+(?:[.,]\d+)?)\s*mm/i);
    var margin = m ? num(m[1]) / 10 : 0.2;
    var out = { type: /vidpad/i.test(rows[0].join(' ')) ? 'insole' : 'range', margin: margin, rows: [] };
    rows.slice(1).forEach(function (r) {
      var size = r[1];
      if (!/^\d+([.,]\d+)?$/.test(size)) return;
      if (out.type === 'insole') {
        var v = num(r[0]); if (v == null) return;
        out.rows.push({ size: size, hi: Math.round((v - margin) * 100) / 100 });
      } else {
        var mm = r[0].match(/(\d+(?:[.,]\d+)?)\s*[-–]\s*(\d+(?:[.,]\d+)?)/);
        if (!mm) return;
        out.rows.push({ size: size, lo: num(mm[1]), hi: num(mm[2]) });
      }
    });
    if (out.rows.length < 3) return null;
    out.rows.sort(function (a, b) { return a.hi - b.hi; });
    return out;
  }
  function lookup(chart, v) {
    var rows = chart.rows;
    if (v < 15 || v > 36) return { err: 'Patikrinkite – ar tikrai ' + fmt(v) + ' cm?' };
    for (var i = 0; i < rows.length; i++) {
      if (v <= rows[i].hi + 1e-9) {
        return { size: rows[i].size, tight: (rows[i].hi - v) < 0.1 && i < rows.length - 1, small: i === 0 && rows[0].lo != null && chart.type === 'range' && v < rows[0].lo - 0.5 };
      }
    }
    return { over: true };
  }

  var s = document.createElement('style');
  s.textContent = [
    '.ml-spt{background:#f7f3ea;border:1px solid rgba(32,27,82,.14);padding:28px;color:#201b52}',
    '.ml-spt__e{margin:0 0 .2rem;font-size:.68rem;letter-spacing:.16em;text-transform:uppercase;color:#a56d4f}',
    '.ml-spt h2{margin:0 0 1.2rem;font-family:var(--ml-serif,"ML Serif",Georgia,serif);font-weight:400;font-size:1.8rem;line-height:1.15;text-transform:none;letter-spacing:0}',
    '.ml-spt__s{margin-bottom:1.2rem}',
    '.ml-spt__h{display:flex;align-items:center;gap:.5rem;margin:0 0 .6rem;font-weight:600;font-size:.92rem}',
    '.ml-spt__h span{display:inline-grid;place-items:center;width:1.5rem;height:1.5rem;border-radius:50%;background:#201b52;color:#fff;font-size:.72rem;font-weight:500}',
    '.ml-spt select,.ml-spt input{width:100%;padding:.85rem .9rem;border:1px solid #201b52;border-radius:0;background:#fff;font:inherit;font-size:16px;color:#201b52}',
    '.ml-spt__row{display:flex;gap:.6rem;align-items:center}.ml-spt__row b{font-weight:400;opacity:.7}',
    '.ml-spt__opts{display:grid;gap:.6rem;margin-top:.7rem}.ml-spt__opts label{display:block;font-size:.78rem;margin-bottom:.25rem;opacity:.75}',
    '.ml-spt__res{margin-top:.8rem;border:1px solid #c49e63;background:#fff;padding:1rem;text-align:center;min-height:5.2rem;display:grid;place-items:center}',
    '.ml-spt__big{display:block;font-family:var(--ml-serif,"ML Serif",Georgia,serif);font-size:2.8rem;line-height:1}',
    '.ml-spt__res small{display:block;margin-top:.4rem;font-size:.82rem;line-height:1.45}',
    '.ml-spt__muted{opacity:.55;font-size:.84rem}.ml-spt__warn{color:#a56d4f}',
    '.ml-spt__fit{margin:.8rem 0 0;display:flex;gap:.5rem;font-size:.8rem;line-height:1.45}.ml-spt__fit:before{content:"";flex:none;width:.5rem;height:.5rem;margin-top:.4rem;border-radius:50%;background:#2f9e57}',
    '.ml-spt__btns{display:flex;gap:.6rem;flex-wrap:wrap;margin-top:1rem}.ml-spt__btns[hidden]{display:none}',
    '.ml-spt__btn{display:inline-block;padding:.85rem 1.2rem;border:1px solid #201b52;background:transparent;color:#201b52;font:inherit;font-size:.74rem;letter-spacing:.1em;text-transform:uppercase;text-decoration:none;cursor:pointer;text-align:center}',
    '.ml-spt__btn--f{background:#201b52;color:#fff}.ml-spt__btn[disabled]{opacity:.5;cursor:default}',
    '.ml-spt__ok{margin:.7rem 0 0;font-size:.84rem}.ml-spt__ok a{color:inherit;text-underline-offset:3px}',
    '.ml-spt__act{display:flex;gap:.6rem;flex-wrap:wrap;margin-top:1.1rem}',
    '.ml-spt__help{margin-top:1.3rem;background:#ebe3d6;padding:1rem;font-size:.84rem;line-height:1.5}',
    '.ml-spt__help b{display:block;margin-bottom:.3rem;font-family:var(--ml-serif,"ML Serif",Georgia,serif);font-weight:400;font-size:1.15rem}.ml-spt__help a{color:inherit;text-underline-offset:3px}',
    '@media(max-width:860px){.ml-spt{padding:18px}}'
  ].join('');
  document.head.appendChild(s);

  var box = document.createElement('div');
  box.className = 'ml-spt';
  box.innerHTML =
    '<p class="ml-spt__e">Dydžio įrankis</p><h2>Rasti mano dydį</h2>' +
    '<div class="ml-spt__s"><p class="ml-spt__h"><span>1</span>Pasirinkite modelį</p><select data-m><option value="">Kraunama…</option></select></div>' +
    '<div class="ml-spt__s"><p class="ml-spt__h"><span>2</span>Įveskite pėdos ilgį</p><div class="ml-spt__row"><input data-f type="text" inputmode="decimal" placeholder="pvz. 24,6" autocomplete="off"><b>cm</b></div>' +
    '<div class="ml-spt__opts" data-o></div>' +
    '<div class="ml-spt__res" data-r><span class="ml-spt__muted">Pasirinkite modelį ir įveskite pėdos ilgį</span></div>' +
    '<div class="ml-spt__btns" data-b hidden></div><p class="ml-spt__ok" data-k hidden></p></div>' +
    '<p class="ml-spt__fit">' + FIT + '</p>' +
    '<div class="ml-spt__act"><button type="button" class="ml-spt__btn" data-p>⎙ Atsispausdinti A4 liniuotę</button><a class="ml-spt__btn" href="/pages/kontaktai">Susisiekti su mumis</a></div>' +
    '<div class="ml-spt__help"><b>Vis dar neaišku?</b>Parašykite <a href="mailto:' + EMAIL + '">' + EMAIL + '</a> arba paskambinkite <a href="tel:' + PHONE + '">' + PHONE_TXT + '</a> – padėsime išsirinkti.</div>';
  mount.appendChild(box);

  var sel = box.querySelector('[data-m]'), inp = box.querySelector('[data-f]'), res = box.querySelector('[data-r]'),
      btns = box.querySelector('[data-b]'), opts = box.querySelector('[data-o]'), ok = box.querySelector('[data-k]');

  function loadModels() {
    return Promise.all(COLS.map(function (c) {
      return fetch('/collections/' + c[0] + '/products.json?limit=250').then(function (r) { return r.json(); }).then(function (j) {
        var seen = {};
        return { label: c[1], items: j.products.filter(function (p) {
          if (/sandėlyje|sandelyje/i.test(p.title)) return false;
          var k = p.title.replace(/["“”]/g, '').split(',')[0].trim().toLowerCase();
          if (seen[k]) return false; seen[k] = 1; return true;
        }).map(function (p) { return { handle: p.handle, title: p.title.replace(/["“”]/g, '').split(',')[0].trim() }; })
          .sort(function (a, b) { return a.title.localeCompare(b.title, 'lt'); }) };
      });
    })).then(function (g) { groups = g; return g; });
  }
  function findModel(handle) {
    var f = null;
    (groups || []).forEach(function (g) { g.items.forEach(function (m) { if (m.handle === handle) f = m; }); });
    return f;
  }
  function selectedVariant() {
    var p = st.prod; if (!p || st.size == null) return null;
    var si = st.sizeIdx, chosen = {};
    [].slice.call(opts.querySelectorAll('select')).forEach(function (x) { chosen[x.dataset.i] = x.value; });
    return p.variants.filter(function (v) {
      return v.options.every(function (val, i) { return i === si ? val === st.size : (chosen[i] == null || chosen[i] === val); });
    })[0] || null;
  }
  function renderBtns() {
    ok.hidden = true;
    if (st.size == null || !st.handle) { btns.hidden = true; return; }
    var v = selectedVariant(), can = v && v.available;
    btns.hidden = false;
    btns.innerHTML = '<button type="button" class="ml-spt__btn ml-spt__btn--f" data-add' + (can ? '' : ' disabled') + '>' +
      (can ? 'Pridėti į krepšelį · dydis ' + st.size : (v ? 'Šio dydžio šiuo metu nėra' : 'Šio varianto nėra')) + '</button>' +
      '<a class="ml-spt__btn" href="/products/' + st.handle + '">Peržiūrėti modelį</a>';
  }
  function calc() {
    st.size = null; ok.hidden = true; btns.hidden = true;
    if (!st.handle) { res.innerHTML = '<span class="ml-spt__muted">Pasirinkite modelį</span>'; return; }
    if (!st.chart) { res.innerHTML = '<span class="ml-spt__muted">' + (st.loading ? 'Kraunama…' : 'Šiam modeliui dydžių lentelės nėra – parašykite mums.') + '</span>'; return; }
    var v = num(inp.value);
    if (v == null) { res.innerHTML = '<span class="ml-spt__muted">Įveskite pėdos ilgį</span>'; return; }
    var r = lookup(st.chart, v);
    if (r.err) { res.innerHTML = '<span class="ml-spt__warn">' + r.err + '</span>'; return; }
    if (r.over || r.small) { res.innerHTML = '<div><span class="ml-spt__warn">Jūsų pėdos ilgis už mūsų lentelės ribų.</span><small>Parašykite mums – padėsime išsirinkti.</small></div>'; return; }
    st.size = r.size;
    res.innerHTML = '<div><span class="ml-spt__big">' + r.size + '</span><small>Jūsų dydis modeliui „' + esc(st.title) + '“.' + (r.tight ? ' Jūsų pėdos ilgis labai arti ribos – jei abejojate, parašykite mums.' : '') + '</small></div>';
    renderBtns();
  }
  function choose(handle) {
    var m = findModel(handle);
    st = { handle: handle, chart: null, prod: null, size: null, loading: !!handle, title: m ? m.title : '' };
    opts.innerHTML = ''; calc();
    if (!handle) return;
    Promise.all([
      fetch('/products/' + handle).then(function (r) { return r.text(); }),
      fetch('/products/' + handle + '.js').then(function (r) { return r.json(); })
    ]).then(function (a) {
      if (st.handle !== handle) return;
      st.chart = parseChart(new DOMParser().parseFromString(a[0], 'text/html'));
      st.prod = a[1]; st.loading = false;
      var si = -1;
      a[1].options.forEach(function (o, i) { if (si < 0 && o.values.length && o.values.every(function (x) { return /^\d+([.,]\d+)?$/.test(x); })) si = i; });
      st.sizeIdx = si;
      var h = '';
      a[1].options.forEach(function (o, i) {
        if (i === si || o.values.length < 2) return;
        h += '<div><label>' + esc(o.name) + '</label><select data-i="' + i + '">' + o.values.map(function (x) { return '<option>' + esc(x) + '</option>'; }).join('') + '</select></div>';
      });
      opts.innerHTML = h; calc();
    }).catch(function () { st.loading = false; calc(); });
  }

  sel.addEventListener('change', function () { choose(sel.value); });
  inp.addEventListener('input', calc);
  opts.addEventListener('change', renderBtns);
  box.querySelector('[data-p]').addEventListener('click', function () {
    if (window.mlPrintRuler) window.mlPrintRuler({ email: EMAIL, phoneText: PHONE_TXT });
  });
  btns.addEventListener('click', function (e) {
    var b = e.target.closest('[data-add]'); if (!b || b.disabled) return;
    var v = selectedVariant(); if (!v) return;
    b.disabled = true; b.textContent = 'Dedama…';
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function () {
        renderBtns();
        ok.hidden = false; ok.innerHTML = '✓ Pridėta į krepšelį. <a href="/cart">Peržiūrėti krepšelį</a>';
        try { document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); } catch (e2) {}
      })
      .catch(function () { renderBtns(); ok.hidden = false; ok.textContent = 'Nepavyko pridėti. Pabandykite dar kartą arba parašykite mums.'; });
  });

  loadModels().then(function (g) {
    sel.innerHTML = '<option value="">Pasirinkite modelį…</option>' + g.map(function (x) {
      return '<optgroup label="' + x.label + '">' + x.items.map(function (m) { return '<option value="' + esc(m.handle) + '">' + esc(m.title) + '</option>'; }).join('') + '</optgroup>';
    }).join('');
    var pre = new URLSearchParams(location.search).get('model');
    if (pre && findModel(pre)) { sel.value = pre; choose(pre); }
  }).catch(function () { sel.innerHTML = '<option value="">Nepavyko įkelti modelių</option>'; });
})();